export default "__VITE_PUBLIC_ASSET__0594da11__"